app.directive('ngDataSetDetails', function ($rootScope) {
    return {
        restrict: 'E',
        templateUrl: '../app/modules/templates/dataSetDetails.html',
        link: function (scope, element, attr) {
        }
    }
});

